// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ya8g","tabsBox":"styles_tabsBox__fqu4H","createButton":"styles_createButton__1sVig"};